<!--中心概况模块首页-->
<template>
  <div id="introduce">
    <sidebar :content="sidebarData"></sidebar>
    <router-view></router-view>
  </div>
</template>

<script>
import sidebar from "@/components/sidebar";
export default {
  data() {
    return {
      sidebarData: {
        title: "中心概况",
        sub: [
          {
            title: "中心简介",
            sub: [],
            url:'/introduce/itroIndex',
          },
          {
            title: "组织架构",
            sub: [],
            url:'/introduce/orgStrut',
          },
          {
            title: "研究团队",
            sub: [],
            url:'/introduce/team',
          },
          {
            title: "科学研究",
            url:'/introduce/direction',
            sub: [
              {
                title: "研究方向",
                url:'/introduce/direction',
              },
              {
                title: "研究项目",
                url:'/introduce/item',
              }
            ]
          }
        ]
      },
      breadContent:[
        {text:'首页',routerName:'index'},
        {text:'中心概况',routerName:'introduce'},
        {text:'中心简介',routerName:'introduce'},
      ]
    };
  },
  components: {
    sidebar,
  }
};
</script>
<style lang="scss" scoped>
#introduce {
  display: flex;

    width: 80%;
    margin: 0 auto;
    padding: 40px 0 160px 0;
}
</style>
